import { z } from "zod/v4";

import { RedirectDtoSchema } from "../../../dtos/redirects";

export const GetRedirectsByExperienceIdRequestPathParamSchema = z.object({
  experienceId: z.uuid(),
});

export type GetRedirectsByExperienceIdRequestPathParamType = z.infer<
  typeof GetRedirectsByExperienceIdRequestPathParamSchema
>;

export const GetRedirectsByExperienceIdResponseBodySchema = z.object({
  redirects: RedirectDtoSchema.array(),
});

export type GetRedirectsByExperienceIdResponseBodyType = z.infer<
  typeof GetRedirectsByExperienceIdResponseBodySchema
>;
